import { useProduct } from './useProducts'

export default useProduct
